import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import LearningStandards from "./routes/DPLearningStandards";
import ScoreCategories from "ScoreCategories";
import AssessmentCategories from "./routes/AssessmentCategories";
import EvaluationCriteria from "EvaluationCriteria";
import AssessmentCriteria from "AssessmentCriteria";
import DPSubjects from "./routes/DPSubjects";
import StudentProfileTemplates from "Administrator/commonComponents/StudentProfileTemplates";
import { updateChildRoutes } from "Administrator/modules/AdministratorModule";
import LearnerProfileAttributes from "Administrator/commonComponents/LearnerProfileAttributes";
import FieldsConfiguration from "Administrator/commonComponents/FieldsConfiguration";
import ManageTemplates from "Administrator/commonComponents/ManageTemplates";
import RoutineAndMealTemplates from "Administrator/commonComponents/RoutineAndMealTemplates";
import AssessmentSetup from "./routes/AssessmentSetup";
import AssessmentToolSetup from "AssessmentToolSetup";
import GradeBoundaries from "./routes/GradeBoundaries";
import EESubjects from "./routes/EESubjects";
import LocalGrades from "Administrator/commonComponents/LocalGrades";
import Atls from "Administrator/commonComponents/Atls";
import GradingPeriods from "Administrator/commonComponents/GradingPeriods";
import GradingPeriodsV3 from "Administrator/commonComponents/GradingPeriodsV3";
import GradingSetup from "Administrator/commonComponents/GradingSetup";
import GradingSetupV2 from "Administrator/commonComponents/GradingSetupV2";
import AssessmentSettingsEvaluationCriteria from "Administrator/commonComponents/AssessmentSettingsEvaluationCriteria";
import GpaAndCredits from "Administrator/commonComponents/GpaAndCredits";
import PlannerElementSetConfiguration from "Administrator/commonComponents/PlannerElementSetConfiguration";
import WorkbookTemplates from "../../commonComponents/WorkbookTemplates";
import ProjectProgressIndicators from "../../commonComponents/ProjectProgressIndicators";
import SubjectStandardsV2 from "Administrator/commonComponents/SubjectStandardsV2";
import Datasets from "Datasets";
import Continuum from "Continuum";
export default store => ({
  path: "dpAcademicSetup",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    const { routes } = nextState;
    const pathname = _.get(nextState, "location.pathname");
    if (_.includes(pathname, "/evaluationCriteria")) {
      const updatedPathname = _.replace(
        pathname,
        "/evaluationCriteria",
        "/evaluation-criteria"
      );
      return replace(updatedPathname);
    }
    store.dispatch(
      updateChildRoutes({
        routes,
        path: "dpAcademicSetup",
        pathId: "DP_ACADEMIC_SETUP",
        type: "replace",
      })
    );
  },
  childRoutes: [
    StudentProfileTemplates(store),
    ScoreCategories(store),
    EvaluationCriteria(store),
    AssessmentCriteria(store),
    DPSubjects(store),
    LearningStandards(store),
    SubjectStandardsV2(store),
    Datasets(store),
    AssessmentToolSetup(store),
    FieldsConfiguration(store),
    PlannerElementSetConfiguration(store),
    ManageTemplates(store),
    RoutineAndMealTemplates(store),
    AssessmentCategories(store),
    LearnerProfileAttributes(store),
    Atls(store),
    AssessmentSetup(store),
    GradeBoundaries(store),
    EESubjects(store),
    LocalGrades(store),
    GradingPeriods(store),
    GradingPeriodsV3(store),
    GradingSetup(store),
    GradingSetupV2(store),
    AssessmentSettingsEvaluationCriteria(store),
    GpaAndCredits(store),
    WorkbookTemplates(store),
    ProjectProgressIndicators(store),
    Continuum(store),
  ],
});
